import { type BasicMenuItemProps } from '@placer-ui/components';

type CsvAddressFields = {
    [K in BasicMenuItemProps['value']]: BasicMenuItemProps[];
};

export type SupportRequestAddressType = 'lat_lng' | 'separate_columns' | 'single_column';

export const csvAddressOptions: BasicMenuItemProps<SupportRequestAddressType>[] = [
    {
        label: 'Lat, Long (Recommended)',
        value: 'lat_lng',
        testId: 'lat-lng-separate-columns',
    },
    {
        label: 'Street, City, State - Separate Columns',
        value: 'separate_columns',
        testId: 'street-city-state-separate-columns',
    },
    {
        label: 'Street, City, State - Single Column',
        value: 'single_column',
        testId: 'street-city-state-single-column',
    },
];

export const csvAddressFields: CsvAddressFields = {
    lat_lng: [
        {
            label: 'Latitude',
            value: 'lat',
        },
        {
            label: 'Longitude',
            value: 'lng',
        },
    ],
    separate_columns: [
        {
            label: 'Street',
            value: 'street',
        },
        {
            label: 'City',
            value: 'city',
        },
        {
            label: 'State',
            value: 'state',
        },
    ],
    single_column: [
        {
            label: 'Street, City, State',
            value: 'formatted_address',
        },
    ],
};
